import { useGridV2OptOut } from "./useGridV2OptOut";
import { GridV2OptOutModal } from "@/modules/flights/components/GridV2OptOutModal";

export interface GridV2OptOutProps {
  open: boolean;
  /** The entry point owns the open state; the modal calls this when done. */
  onClose: () => void;
}

/**
 * The "use previous pricing" confirmation, connected: the entry point (the
 * Refreshed banner link, RBC-2560) only opens it; the opt-out itself,
 * tracking and re-shop live in `useGridV2OptOut`.
 */
export const GridV2OptOut = ({ open, onClose }: GridV2OptOutProps) => {
  const { optOut } = useGridV2OptOut();
  return <GridV2OptOutModal open={open} onClose={onClose} onOptOut={optOut} />;
};
